module.exports = __webpack_public_path__ + "static/img/qr-code-bg.1ac5acb2.png";